import axios from "axios";
import { createContext, useContext, useState, useEffect } from "react";
import { newBaseUrl } from "../Consts";

export const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export default function AuthContextProvider({ children }) {
    const [isUser, setIsUser] = useState(null);
    const [isAuth, setIsAuth] = useState(!!localStorage.getItem('token'));

    async function getUser(lang = 'en') {
        try {
            const headers = {
                'Content-Type': 'application/json',
                'Content-Language': lang,
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            };

            const res = await axios.get(`${newBaseUrl}/api/admin/user`, { headers });

            if (res?.data?.success) {
                setIsUser(res.data.data);
            } else {
                setIsUser(null);
                setIsAuth(false);
            }
        } catch (err) {
            setIsUser(null);
            setIsAuth(false);
        }
    }

    useEffect(() => {
        if (isAuth) getUser();
    }, [isAuth]);

    return (
        <AuthContext.Provider value={{
            isAuth,
            setIsAuth,
            isUser,
            setIsUser,
            getUser
        }}>
            {children}
        </AuthContext.Provider>
    );
}